import { generateAutomationName } from "../../../../../helpers/generateAutomationName";

export const deleteButtonsKeys = {
    closeButton: generateAutomationName("home", ["topics", "modal", "item", "topic", "cancel", "button"]),
    deleteTopicAndKW: generateAutomationName("home", ["topics", "modal", "item", "topic", "delete", "kw", "button"]),
    deleteTopic: generateAutomationName("home", ["topics", "modal", "item", "topic", "delete", "button"]),
};

export const deleteTopicFlowKeys = {
    header: generateAutomationName("home", ["topics", "modal", "header"]),
    title: generateAutomationName("home", ["topics", "modal", "title"]),
    body: generateAutomationName("home", ["topics", "modal", "body"]),
};
